import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "semantic-ui-css/semantic.min.css";
import { I18nProvider } from "./i18n";

ReactDOM.render(
  <I18nProvider>
    <App />
  </I18nProvider>,
  document.getElementById("root")
);
